import { AutoComplete, Input, Spin } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { searchApi } from "../../../apiservice/setting";
import React, { useState, useRef } from "react";

const MODULE_ICONS = {
  dashboard: "🏠",
  sales: "🧾",
  invoice: "🧾",
  purchase: "🛒",
  order: "📋",
  quotation: "📝",
  inventory: "📦",
  accounts: "💰",
  hrpayroll: "👥",
  service: "🔧",
  manufacturing: "🏭",
  delivery: "🚚",
  crm: "🤝",
  ats: "📌",
  settings: "⚙️",
  pos: "🖥️",
  workflow: "🔄",
  reports: "📊",
};

function getIcon(path = "") {
  const segment = path.split("/").filter(Boolean)[0] || "";
  return MODULE_ICONS[segment] || "📄";
}

const SearchBox = ({ fullScreen = false, onSelect }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState("");
  const [open, setOpen] = useState(false);
  const authInfo = useSelector((state) => state.auth.auth_info);
  const navigate = useNavigate();
  const timeoutRef = useRef(null);

  const handleSearch = (term) => {
    setValue(term);

    if (!term.trim()) {
      setOptions([]);
      setOpen(false);
      return;
    }

    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(async () => {
      try {
        setLoading(true);
        const payload = {
          role_id: authInfo?.user_role_id,
          search_term: term,
        };
        const res = await searchApi(payload);
        const results = Array.isArray(res?.data) ? res.data : [];

        // Dedupe by path
        const unique = Array.from(
          new Map(results.map((item) => [item.path, item])).values()
        );

        setOptions(
          unique.map((item) => ({
            value: item.path,
            key: item.path,
            label: (
              <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "2px 0" }}>
                <span style={{ fontSize: 16, lineHeight: 1 }}>{getIcon(item.path)}</span>
                <span style={{ fontSize: 13 }}>{item.name}</span>
                <span style={{ marginLeft: "auto", fontSize: 11, color: "#bbb", fontFamily: "monospace" }}>
                  {item.path}
                </span>
              </div>
            ),
          }))
        );
        setOpen(true);
      } catch (err) {
        console.error("Search error:", err);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 250);
  };

  const handleSelect = (path) => {
    navigate(path);
    setValue("");
    setOptions([]);
    setOpen(false);
    if (onSelect) onSelect();
  };

  const handleClear = () => {
    setValue("");
    setOptions([]);
    setOpen(false);
  };

  return (
    <AutoComplete
      value={value}
      options={options}
      open={open && options.length > 0}
      onSelect={handleSelect}
      onSearch={handleSearch}
      popupMatchSelectWidth={440}
      dropdownStyle={{ borderRadius: 10, boxShadow: "0 6px 24px rgba(0,0,0,0.12)" }}
      style={{ width: fullScreen ? "100%" : 320 }}
      notFoundContent={null}
    >
      <Input
        autoFocus={fullScreen}
        prefix={loading ? <Spin size="small" /> : <SearchOutlined style={{ color: "#aaa" }} />}
        placeholder="Search pages & modules..."
        allowClear
        onClear={handleClear}
        style={{
          borderRadius: 20,
          background: "#f5f5f5",
          border: "1px solid #e8e8e8",
          paddingLeft: 12,
          fontSize: 13,
          height: 36,
          boxShadow: "none",
        }}
      />
    </AutoComplete>
  );
};

export default SearchBox;
